import { Moment } from 'moment';

import { SchoolHolidayTerm, SchoolHolidayType } from '../../legacy/types';
import {
  getCurrentOrUpcomingSchoolPeriod,
  getCurrentSchoolPeriod,
  getUpcomingSchoolPeriod,
  isWithinSchoolPeriod,
} from './sharedSchoolPeriodHelpers';

export const schoolHolidayTypes: SchoolHolidayType[] = [
  'Summer Holiday',
  'Winter Holiday',
  'Spring Holiday',
  'Autumn Holiday',
];

export const isWithinSchoolHoliday = (date: string | Moment, holiday: SchoolHolidayTerm) => {
  return isWithinSchoolPeriod(date, holiday);
};

export const getCurrentSchoolHoliday = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getCurrentSchoolPeriod(upcomingTermsAndHolidays, schoolHolidayTypes, overrideCurrentDate);
};

export const getUpcomingSchoolHoliday = (
  schoolTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getUpcomingSchoolPeriod(schoolTermsAndHolidays, schoolHolidayTypes, overrideCurrentDate);
};

export const getCurrentOrUpcomingSchoolHoliday = (
  upcomingTermsAndHolidays: Array<SchoolHolidayTerm>,
  overrideCurrentDate?: string | Moment
) => {
  return getCurrentOrUpcomingSchoolPeriod(upcomingTermsAndHolidays, schoolHolidayTypes, overrideCurrentDate);
};
